// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"D2-z","dimensionLabel":"E2-z","styleChooserControlWrapper":"F2-z","styleChooserControl":"G2-z","disabled":"H2-z","giftCard":"I2-z","styleChooserText":"J2-z"};